import React from 'react';
import { useNavigate } from 'react-router-dom';
import './emptystate.scss';

const EmptyState = ({ 
  title = "No Projects Yet",
  description = "Get started by creating your first integration project",
  icon = "folder", // 'folder', 'search', 'document', 'box'
  primaryAction,
  secondaryAction,
  showActions = true
}) => {
  const navigate = useNavigate();




  // Icon SVGs
  const icons = {
    folder: (
      <svg className="empty-icon-svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 30 L50 30 L60 20 L100 20 L100 90 L20 90 Z" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round"/>
        <rect x="20" y="40" width="80" height="50" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              rx="4"/>
        <line x1="35" y1="55" x2="85" y2="55" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="4 4" 
              opacity="0.5"/>
        <line x1="35" y1="65" x2="70" y2="65" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="4 4" 
              opacity="0.5"/>
        <line x1="35" y1="75" x2="75" y2="75" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="4 4" 
              opacity="0.5"/>
      </svg>
    ),
    search: (
      <svg className="empty-icon-svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="25" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"/>
        <line x1="70" y1="70" x2="90" y2="90" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round"/>
        <line x1="45" y1="40" x2="55" y2="40" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="2 4" 
              opacity="0.5"/>
        <line x1="40" y1="50" x2="60" y2="50" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="2 4" 
              opacity="0.5"/>
        <line x1="45" y1="60" x2="55" y2="60" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="2 4" 
              opacity="0.5"/>
      </svg>
    ),
    document: (
      <svg className="empty-icon-svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <path d="M30 20 L75 20 L90 35 L90 100 L30 100 Z" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round"/>
        <path d="M75 20 L75 35 L90 35" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round"/>
        <line x1="40" y1="50" x2="80" y2="50" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="4 4" 
              opacity="0.5"/>
        <line x1="40" y1="60" x2="70" y2="60" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="4 4" 
              opacity="0.5"/>
        <line x1="40" y1="70" x2="75" y2="70" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeDasharray="4 4" 
              opacity="0.5"/>
      </svg>
    ),
    box: (
      <svg className="empty-icon-svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <path d="M30 40 L60 25 L90 40 L90 80 L60 95 L30 80 Z" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"/>
        <line x1="60" y1="25" x2="60" y2="95" 
              stroke="currentColor" 
              strokeWidth="2" 
              opacity="0.3"/>
        <line x1="30" y1="40" x2="90" y2="40" 
              stroke="currentColor" 
              strokeWidth="2" 
              opacity="0.3"/>
      </svg>
    )
  };

  return (
    <div className="empty-state-component">
      <div className="empty-state-content">
        {/* Icon */}
        <div className="empty-icon-wrapper">
          {icons[icon] || icons.folder}
        </div>

        {/* Text */}
        <h3 className="empty-title">{title}</h3>
        <p className="empty-description">{description}</p>

       
      </div>
    </div>
  );
};

export default EmptyState;